import StaticContentStore from "./StaticContentStore";

const staticContentStore = new StaticContentStore();

export default staticContentStore;
